export default __webpack_public_path__ + "static/media/certification.12eee0bc.svg";